import { render, staticRenderFns } from "./rooms_in_quest.vue?vue&type=template&id=5741d5e8&"
import script from "./rooms_in_quest.vue?vue&type=script&lang=js&"
export * from "./rooms_in_quest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports